<script>
// src/components/Portal.svelte
import { onMount, onDestroy } from 'svelte'
let ref
let portal
const doc = document

onMount(() => {
  portal = doc.createElement('div')
  portal.className = 'portal'
  document.body.appendChild(portal)
  portal.appendChild(ref)
})

onDestroy(() => {
  console.log("Portal destroy")
  doc.body.removeChild(portal)
})

</script>

<div bind:this={ref}>
  <slot></slot>
</div>

<style>

  :global(.portal){
    z-index:10000;
    position: fixed;
    padding:none;
  }
</style>
